import { render } from "./role-list.vue?vue&type=template&id=7a7cbefa"
import script from "./role-list.vue?vue&type=script&lang=ts"
export * from "./role-list.vue?vue&type=script&lang=ts"
script.render = render

export default script